/**
 * @file Hook wrapping the `startSignifyFetchJob` callable. Consumer: `useSignifyFetchJobEntry`,
 * whose Start button turns the staged list into a job document and a queued task.
 * `loading` is what keeps Start from dispatching the same list twice while the callable is in
 * flight; `execute` rethrows the callable's own error so the caller can report it — code included —
 * and leave the draft intact, which is the whole recovery path: the operator presses Start again.
 */

import { useCallback } from 'react';
import type { StartSignifyFetchJobRequest, StartSignifyFetchJobResponse } from '#types';
import { startSignifyFetchJob } from '../services/signifyApiService';
import { useSignifyApi } from './useSignifyApi';

export const useStartSignifyFetchJob = () => {
  const api = useSignifyApi<StartSignifyFetchJobResponse>();

  const startFetchJob = useCallback(
    async (request: StartSignifyFetchJobRequest): Promise<StartSignifyFetchJobResponse> =>
      api.execute(() => startSignifyFetchJob(request)),
    [api],
  );

  return {
    starting: api.loading,
    error: api.error,
    startFetchJob,
  };
};
